<template>
    <app-layout class="insurance-plans">
        <common-content-spacer height="medium">
            <common-content-spacer height="small">
                <common-breadcrumbs :breadcrumbs="pageBreadcrumbs"></common-breadcrumbs>
            </common-content-spacer>
            <common-page-header :heading="pageTitle" size="minor"></common-page-header>

            <common-page-plain>
                <common-content-spacer height="medium">
                    <ancillary-service-tests-table
                        :ancillaryServices="ancillaryServices"
                        :prefillValues="prefillValues"
                        :showHeader="false"
                        @ancillary-selection-save="saveChanges"
                    ></ancillary-service-tests-table>
                </common-content-spacer>
            </common-page-plain>
        </common-content-spacer>
    </app-layout>
</template>

<script>
    import PageWithTitleMixin from 'mixins/PageWithTitleMixin'
    import PageWithElementsMixin from 'mixins/PageWithElementsMixin'
    import AppLayout from 'components/layouts/AppLayout'
    import AncillaryServiceTestsTable from 'components/page-elements/ancillary-service-tests/AncillaryServiceTestsTable'
    import FacilityServicesAPI from 'api/FacilityServicesAPI'

    export default {
        mixins: [PageWithTitleMixin, PageWithElementsMixin],

        components: {
            AppLayout,
            AncillaryServiceTestsTable,
        },

        data() {
            return {
                ancillaryServices: [],
                isLoading: false,
                prefillValues: [],
            }
        },

        computed: {
            pageTitle() {
                return this.$t('pages.practice.profile.titles.practice_profile', {
                    practiceName: this.$route.query.practiceName ? this.$route.query.practiceName : this.$auth.getPractice().name,
                })
            },

            pageSubTitle() {
                return this.$t('pages.practice.insurance.titles.insurance_plans_accepted')
            },

            pageBreadcrumbs() {
                return [
                    {
                        label: this.$t('pages.practice.insurance.breadcrumbs.practice'),
                        route: { name: 'practice.members' },
                    },
                    {
                        label: this.$t('pages.practice.insurance.breadcrumbs.practice_profile'),
                        route: { name: 'practice.profile-ancillary' },
                    },
                    {
                        label: this.$t('pages.practice.profile.breadcrumbs.practice_services'),
                    },
                ]
            },
        },

        methods: {
            saveChanges(value) {
                const query = {
                    ...this.$route.query,
                    insurancePlanId: this.$route.query.insurancePlanId,
                    referralTests: value.map((item) => item.id),
                }
                this.$router.push({
                    name: `referrals.new.make`,
                    query: query,
                    params: {
                        existingReferral: this.existingReferral,
                    },
                })
            },

            loadAncillary() {
                const query = {
                    practiceLocationId: this.$route.query.practiceLocationId,
                    practiceId: this.$route.query.practiceId,
                }
                FacilityServicesAPI.getFacilityServiceGroups(query, [
                    'id',
                    'name',
                    'facilityServiceTypes(id,name,facilityServiceTypesGroups(id,name,typeId,facilityServiceTypesSubgroups(id,name,facilityServiceTests(id,name))))',
                ]).then((response) => {
                    this.ancillaryServices = response.filter((serviceType) => {
                        serviceType.facilityServiceTypes = serviceType.facilityServiceTypes.filter(
                            (service) => service.facilityServiceTypesGroups.length,
                        )
                        serviceType.facilityServiceTypes.map((item) => {
                            item.expanded = false
                        })
                        return serviceType.facilityServiceTypes.some((service) => service.facilityServiceTypesGroups.length)
                    })

                    if (this.$route.query.testIds) {
                        this.setPrefillValues()
                    }
                })
            },

            setPrefillValues() {
                const testIds = this.$route.query.testIds
                    .toString()
                    .split(',')
                    .map((item) => Number(item))
                const checkedValues = []

                this.ancillaryServices.forEach((type) => {
                    type.facilityServiceTypes.forEach((service) => {
                        service.facilityServiceTypesGroups.forEach((group) => {
                            group.facilityServiceTypesSubgroups.forEach((subGroup) => {
                                subGroup.facilityServiceTests.forEach((test) => {
                                    if (testIds.includes(test.id)) {
                                        checkedValues.push(test)
                                        service.expanded = true
                                    }
                                })
                            })
                        })
                    })
                })

                this.prefillValues = checkedValues
            },
        },

        mounted() {
            this.loadAncillary()
        },
    }
</script>

<style lang="scss" scoped>
    .insurance-plans {
        &__back-button {
            .icon {
                margin-top: 10px;
            }
        }
    }
</style>
